import { create } from 'zustand'

interface ThemeState {
  isDark: boolean
  toggle: () => void
}

// Voysi flamingo rebrand defaults the app to light. The dark token set is
// still present in `index.css` under `[data-theme="dark"]`, but no consumer
// applies that attribute today — the Header's theme button still toggles
// `isDark` state for future use.
export const useThemeStore = create<ThemeState>((set) => ({
  isDark: false,
  toggle: () => set((state) => ({ isDark: !state.isDark })),
}))
